import { Arl } from "@/interfaces/Arl";
import {
  // AcquiredCertifications,
  AcquiredCertificationsArray,
  // Ciiu,
  CiiuArray,
  CreateCompanyDto,
} from "@/interfaces/Company";
import { SegmentArray } from "@/interfaces/Segment";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  createCompanyData: {
    company_name: "",
    company_nit: "",
    company_email: "",
    company_dependant: null,
    company_dependant_phone: null,
    company_dependant_position: null,
    company_segment: null,
    company_arl: null,
    ciius_codes: [],
    acquired_certifications_codes: [],
    enable_for_counting: false,
    external_user: false,
    size: null,
    schedule: null,
  } as CreateCompanyDto,
  segments: { segments: [] } as SegmentArray,
  arlData: [] as Arl[],
  ciiuData: { ciius: [] } as CiiuArray,
  certifications: { acquired_certifications: [] } as AcquiredCertificationsArray,
};

export const companyFormSlice = createSlice({
  name: "companyForm",
  initialState,
  reducers: {
    fillFormField(state, action: PayloadAction<Partial<CreateCompanyDto>>) {
      state.createCompanyData = {
        ...state.createCompanyData,
        ...action.payload,
      };
    },
    resetForm() {
      return initialState;
    },
    setSegments: (state, action: PayloadAction<SegmentArray>) => {
      state.segments = action.payload;
    },
    setArlData: (state, action: PayloadAction<Arl[]>) => {
      state.arlData = action.payload;
    },
    setCiiuData: (state, action: PayloadAction<CiiuArray>) => {
      state.ciiuData = action.payload;
    },
    setCertifications: (
      state,
      action: PayloadAction<AcquiredCertificationsArray>
    ) => {
      state.certifications = action.payload;
    },
  },
});

export const {
  fillFormField,
  resetForm,
  setSegments,
  setArlData,
  setCiiuData,
  setCertifications,
} = companyFormSlice.actions;
export default companyFormSlice.reducer;
